import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import apiSlice from "../features/api/api.slice";
import { rootReducer } from "../reducers";

const devTools = process.env.NODE_ENV !== "production" && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__()
    : (a) => a;

const middleware = compose(applyMiddleware(thunk,apiSlice.middleware), devTools);
const store = createStore(rootReducer, middleware);
export { store };